// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ behavior = "auto" }) {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // if there's a hash (anchor) - scroll to that element, otherwise top
        if (hash) {
            // try to find element matching the hash
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior });
                return;
            }
        }

        // default: scroll to top
        window.scrollTo({ top: 0, left: 0, behavior });
    }, [pathname, hash, behavior]);

    return null;
}
